import React from "react";
import {OnSubmitFadedLoader} from "./Styled";

const SignUpFormOnSubmitContentLoader: React.FC = () => {
    return (
        <>
            <OnSubmitFadedLoader />
        </>
    );
};

export default SignUpFormOnSubmitContentLoader;
